<template>
  <div>
    <Dialog
      width="781px"
      :height="createRenderType == 'pc' ? '618px' : '100%'"
      :mobileRenderType="createRenderType == 'pc' ? '' : 'drawerDialog'"
      :customClass="`${createRenderType}-expiration-dialog`"
      titleAlign="left"
      :title="$t('credit.viewDate')"
      :visible="dialogVisible"
      @close="onClose"
    >
      <div
        class="flex-column height-all view-box"
        :class="`${createRenderType}-view-box`"
      >
        <div v-if="createRenderType == 'mobile'" class="show-card flex-column">
          <div class="title">{{ $t("credit.remainingCredits") }}</div>
          <div class="credit flex1">{{ userDataStore?.credits || 0 }}</div>
          <div  class="flex flex-space-between" v-if="globleConfig.appname == 'Mureka'">
            <div>
              <div class="num">
                {{ showData.monthly_reset_gold || 0 }} /
                {{ showData.monthly_reset_total || 0 }}
              </div>
              <div class="name">{{ $t("credit.resetsMonthly") }}</div>
            </div>
            <div >
              <div class="num">
                {{ showData.purchased_gold || 0 }} /
                {{ showData.purchased_total || 0 }}
              </div>
              <div class="name">{{ $t("credit.purchaseDirectly") }}</div>
            </div>
            <div>
              <div class="num">
                {{ showData.daily_reset_gold || 0 }} /
                {{ showData.daily_reset_total || 0 }}
              </div>
              <div class="name">{{ $t("credit.free") }}</div>
            </div>
          </div>
        </div>
        <div v-if="createRenderType == 'pc'" class="flex name-box">
          <div>{{ $t("credit.purchaseDate") }}</div>
          <div>{{ $t("credit.credits") }}</div>
          <div>{{ $t("credit.used") }}</div>
          <div>{{ $t("credit.left") }}</div>
          <div>{{ $t("credit.expirationDate") }}</div>
        </div>
        <div class="flex1 height-0">
          <PullTo
            v-if="!renderData.loadError"
            :datas="renderData.list"
            v-model:refreshing="renderData.refreshing"
            v-model:loadingMore="renderData.loadingMore"
            v-model:isLoading="renderData.isLoading"
            v-model:finished="renderData.finished"
            @refresh="doRefresh"
            @loadMore="doLoadMore"
          >
            <template v-slot:default="slotProps">
              <div v-if="createRenderType == 'pc'" class="item flex">
                <div class="">
                  {{
                    tools.formatDate(
                      slotProps.item.created_at * 1000,
                      "MM/DD/YYYY"
                    )
                  }}
                </div>
                <div class="">
                  {{ slotProps.item.credit
                  }}{{
                    slotProps.item.way == 3 || slotProps.item.way == 25
                      ? `(${$t("credit.free")})`
                      : slotProps.item.way == 5
                      ? `(${$t("credit.rewarded")})`
                      : slotProps.item.way == 9
                      ? `(${$t("credit.invite")})`
                      : ""
                  }}
                </div>
                <div class="">{{ slotProps.item.used_credit || 0 }}</div>
                <div class="">
                  {{
                    slotProps.item.state > 2
                      ? `${slotProps.item.expired_credit}(${$t(
                          "credit.expired"
                        )})`
                      : slotProps.item.rest_credit || 0
                  }}
                </div>
                <div class="">
                  {{
                    slotProps.item.way == 7
                      ? slotProps.item.expire_desc
                      : tools.formatDate(
                          slotProps.item.expired_on * 1000,
                          "MM/DD/YYYY"
                        )
                  }}
                </div>
              </div>
              <div v-else class="monile-item">
                <div class="flex-space-between citem">
                  <div class="name value">{{ $t("credit.purchaseDate") }}</div>
                  <div class="value">
                    {{
                      tools.formatDate(
                        slotProps.item.created_at * 1000,
                        "MM/DD/YYYY"
                      )
                    }}
                  </div>
                </div>
                <div class="flex-space-between citem">
                  <div class="name value">{{ $t("credit.credits") }}</div>
                  <div class="value">
                    {{ slotProps.item.credit
                    }}{{
                      slotProps.item.way == 3 || slotProps.item.way == 25
                        ? `(${$t("credit.free")})`
                        : slotProps.item.way == 5
                        ? `(${$t("credit.rewarded")})`
                        : slotProps.item.way == 9
                        ? `(${$t("credit.invite")})`
                        : ""
                    }}
                  </div>
                </div>
                <div class="flex-space-between citem">
                  <div class="name value">{{ $t("credit.used") }}</div>
                  <div class="value">{{ slotProps.item.used_credit || 0 }}</div>
                </div>
                <div class="flex-space-between citem">
                  <div class="name value">{{ $t("credit.left") }}</div>
                  <div class="value">
                    {{
                      slotProps.item.state > 2
                        ? `${slotProps.item.expired_credit}(${$t(
                            "credit.expired"
                          )})`
                        : slotProps.item.rest_credit || 0
                    }}
                  </div>
                </div>
                <div class="flex-space-between citem">
                  <div class="name value">
                    {{ $t("credit.expirationDate") }}
                  </div>
                  <div class="value">
                    {{
                      slotProps.item.way == 7
                        ? slotProps.item.expire_desc
                        : tools.formatDate(
                            slotProps.item.expired_on * 1000,
                            "MM/DD/YYYY"
                          )
                    }}
                  </div>
                </div>
              </div>
            </template>
          </PullTo>
          <QueryEmptyRetry
            v-if="renderData.loadError"
            @retry="
              () => {
                doRetry(true);
              }
            "
          ></QueryEmptyRetry>
        </div>
        <div class="tip">{{ $t("credit.dataBasis") }}</div>
      </div>
    </Dialog>
  </div>
</template>

<script setup>
import { ref, defineProps, onMounted, watch, defineEmits } from "vue";
import { storeToRefs } from "pinia";
import QueryEmptyRetry from "@/components/basic/pullTo/queryEmptyRetry.vue";
import PullTo from "@/components/basic/pullTo/PullTo.vue";
import { getOrderCreditList } from "@/api/api/apiCredit.js";
import tools from "@/utils/tools.js";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import useUserDataStore from "@/store/userDataStore.js";
import globleConfig, { ModuleOpenStateControl } from "@/config/config.js";

const userDataStore = useUserDataStore();
const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  showData: {
    type: Object,
    default: () => ({}),
  },
});
const createLayoutStore = useCreateLayoutStore();
const { createRenderType } = storeToRefs(createLayoutStore);
const emits = defineEmits(["update:visible"]);

const dialogVisible = ref(props.visible);
const renderData = reactive({
  list: [],
  refreshing: false,
  loadingMore: false,
  isLoading: false,
  loadError: false,
  finished: false,
});
const lastId = ref("");

watch(
  () => dialogVisible,
  (val) => {
    emits("update:visible", val);
  }
);

watch(
  () => props.visible,
  (val) => {
    dialogVisible.value = val;
  }
);

const doRetry = () => {
  lastId.value = "";
  renderData.isLoading = true;
  renderData.loadError = false;
  getOrderCreditList({
    last_id: lastId.value,
    size: 10,
  }).then((res) => {
    if (res.code == 200) {
      renderData.isLoading = false;
      renderData.loadError = false;
      const { data } = res;
      if (!data.list) {
        renderData.finished = true;
        renderData.list = [];
      } else {
        renderData.list = data.list;
        lastId.value = data?.last_id ? data?.last_id : 0;
        renderData.finished = true;
      }
    } else {
      renderData.isLoading = false;
      renderData.loadError = true;
    }
  });
};

const doRefresh = (done) => {
  lastId.value = "";
  renderData.isLoading = false;
  getOrderCreditList({
    last_id: "",
    size: 10,
  }).then((res) => {
    if (res.code == 200) {
      const { data } = res;
      if (!data.list) {
        renderData.finished = true;
        renderData.list = [];
        done(renderData, true);
      } else {
        renderData.list = data.list;
        lastId.value = data?.last_id ? data?.last_id : 0;
        renderData.finished = true;
        done(renderData, false);
      }
    } else {
      renderData.loadError = true;
    }
  });
};

const doLoadMore = (done) => {
  renderData.isLoading = true;
  getOrderCreditList({
    last_id: lastId.value,
    size: 10,
  }).then((res) => {
    if (res.code == 200) {
      const { data } = res;
      if (!data.list) {
        renderData.finished = true;
        done(renderData, true);
      } else {
        renderData.list = [...renderData.list, ...data.list];
        lastId.value = data?.last_id ? data?.last_id : 0;
        renderData.finished = true;
        done(renderData, false);
      }
    } else {
      renderData.loadError = true;
    }
  });
};

const onClose = () => {
  dialogVisible.value = false;
  emits("update:visible", false);
};

onMounted(() => {
  doRetry();
});
</script>

<style lang="scss">
.mobile-expiration-dialog {
  .dialog-box {
    top: 0;
    max-height: 100%;
    border-radius: 0;
  }
}
</style>

<style scoped lang="scss">
.view-box {
  font-family: HarmonyOS Sans SC;
  color: #fff;
  padding: 40px;
  .name-box {
    padding: 12px 20px;
    color: rgba(255, 255, 255, 0.6);
    background: rgba(255, 255, 255, 0.1);
    div {
      width: 25%;
      display: flex;
      align-items: center;
    }
  }
  .item {
    padding: 22px 20px;
    color: #fff;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    div {
      width: 25%;
    }
  }
  .tip {
    padding-top: 8px;
    text-align: center;
    font-size: 12px;
    font-weight: normal;
    line-height: 20px;
    color: #fff;
  }
}
.mobile-view-box {
  padding: 28px 16px 8px;
  .show-card {
    box-sizing: border-box;
    height: 180px;
    background: url("@/assets/img/credit/card-bg.png");
    background-size: 100% 100%;
    padding: 24px 28px 16px 30px;
    margin-bottom: 16px;
    .title {
      font-size: 14px;
      font-weight: normal;
      line-height: 24px;
      opacity: 0.6;
    }
    .credit {
      text-align: center;
      font-size: 40px;
      font-weight: bold;
      line-height: 48px;
    }
    .num {
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      opacity: 0.8;
      text-align: center;
    }
    .name {
      font-size: 12px;
      line-height: 20px;
      opacity: 0.4;
      text-align: center;
    }
  }
  .monile-item {
    border-radius: 12px;
    padding: 10px 16px;
    background: rgba(3, 19, 41, 0.2);
    border: 1px solid rgba(216, 216, 216, 0.1);
    margin-bottom: 16px;
    .citem {
      padding: 4px 0;
      .name {
        opacity: 0.6;
      }
      .value {
        font-size: 12px;
        font-weight: normal;
        line-height: 24px;
      }
    }
  }
}
</style>